import { render } from "./AdminUserProfile.vue?vue&type=template&id=552c28ed&scoped=true"
import script from "./AdminUserProfile.vue?vue&type=script&lang=js"
export * from "./AdminUserProfile.vue?vue&type=script&lang=js"

import "./AdminUserProfile.vue?vue&type=style&index=0&id=552c28ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552c28ed"]])

export default __exports__